import type { ReportHistoryEntryType as ApiReportHistoryEntryType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../common';
import { mapRecipientCustomType } from '../../../mapGetAllRecipientGroupsResponseType/helpers/mapRecipientCustomType';
import { mapReportHistoryPersonRecipientType } from '../mapReportHistoryPersonRecipientType';
import type { ReportHistoryEntryType } from '../../types';

export const mapReportHistoryEntryType = (
  api: ApiReportHistoryEntryType
): ReportHistoryEntryType => ({
  id: api.id,
  reportConfigurationLabel: api.reportConfigurationLabel,
  date: api.date,
  trigger: api.trigger,
  status: api.status,
  generated: api.generated,
  personRecipients: api.personRecipients.map(
    mapReportHistoryPersonRecipientType
  ),
  customRecipients: api.customRecipients.map(mapRecipientCustomType),
  reviewedAt: api.reviewedAt,
  reviewedBy:
    api.reviewedBy === null ? null : mapLinkableEntityType(api.reviewedBy),
  reportDownloadUrl: api.reportDownloadUrl,
});
